import Openable from 'utils/lib/openable';

class Drawer extends Openable {
  constructor(element) {
    super(element);

    this.classes = {
      active: 'drawer--active',
    };
  }
}

export default (element: string | HTMLElement): Drawer => new Drawer(element);
